export default __webpack_public_path__ + "static/media/homepage-mobile.5c0fc148.mp4";